//React lib
import { Box, Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { useState } from "react";
//Third party lib
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
//Internal lib
import Field from "../../component/Field";
import TypographyLabel from "../../component/Typography";
import { AppDispatch } from "../../store/store";
import "../login/Auth.scss";
//Icon
import lockIcon from "../../assets/images/lock2.png";
import lockIconGa from "../../assets/images/ga/wrong-password.png";
import { changePasswordInt } from "../../store/changePasswordSlice";
import ActionButton from "../../component/ActionButton";
import Toaster from "../../component/Toaster";
import { resetPassword } from "../../store/resetPasswordSlice";
import { THEME } from "../../util/LookupConst";
import { Product } from "../../util/Utils";

const ResetPassword = () => {
  const passwordMinLength: number = 8;
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const initialValue: changePasswordInt = {
    email: "",
    mobileNo: "",
    otp: 0,
    password: "",
    confirmPassword: "",
    otpToken: "",
  };
  const [actionProgress, setActionProgress] = useState(false);

  // API call
  const handleSubmit = (values: any) => {
    setActionProgress(true);
    const requestParam: any = location.state;
    requestParam["password"] = values.password;
    requestParam["confirmPassword"] = values.password;
    dispatch(resetPassword(requestParam))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          Toaster.success(undefined, result.payload.data.message);
          navigate("/login");
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {})
      .finally(() => {
        setActionProgress(false);
      });
  };

  return (
    <Box>
      <Grid
        container
        rowSpacing={1}
        className="center main login-module-background"
      >
        <Grid item xs={10} md={10} lg={10}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 1 }}
            className="viewport-height top-center"
          >
            <Grid item xs={12} sm={12} md={12} lg={12}></Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div className="logo center">
                <span className="login-module-brand-icon"></span>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              className="box-shadow padding-y-20"
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                className="new-bass center"
              >
                <div className="center">
                  <div>
                    <img
                      alt="ImageLock"
                      className="lock-img"
                      src={
                        Product.ProductCode() === THEME.GA
                          ? lockIconGa
                          : lockIcon
                      }
                    />
                  </div>
                  <div className="margin-left-20">
                    <div className="padding-y-10 font-14">
                      <TypographyLabel
                        className="form-label"
                        title={t("passwordMustContain")}
                      />
                    </div>
                    <div className="padding-y-10">
                      <TypographyLabel
                        className="lite-text"
                        title={t("atLeastMin")}
                      />
                    </div>
                    <div className="padding-y-10">
                      <TypographyLabel
                        className="lite-text"
                        title={t("itCanHaveAlphaNumeric")}
                      />
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} lg={6}>
                <div className="new-password-form center">
                  <Formik
                    initialValues={initialValue}
                    onSubmit={handleSubmit}
                    validationSchema={Yup.object().shape({
                      password: Yup.string()
                        .required(`${t("resetPassword.passwordIsRequired")}`)
                        .min(
                          passwordMinLength,
                          `${t("resetPassword.passwordMinLengthErrorMessage", {
                            passwordLength: passwordMinLength,
                          })}`
                        ),
                      confirmPassword: Yup.string()
                        .required(
                          `${t("resetPassword.reEnterPasswordIsRequired")}`
                        )
                        .oneOf(
                          [Yup.ref("password")],
                          `${t("resetPassword.passwordSame")}`
                        ),
                    })}
                  >
                    {({
                      values,
                      handleChange,
                      handleBlur,
                      errors,
                      touched,
                    }: any) => {
                      return (
                        <Form>
                          <div className="flex-container">
                            <TypographyLabel
                              className="form-label"
                              title={t("newPassword")}
                            />
                            <Field
                              className="textFiled"
                              placeholder={t("resetPassword.maskedText")}
                              name="password"
                              type="password"
                              id="change-pass-field"
                              value={values.password}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={errors.password && touched.password}
                            />
                            <TypographyLabel
                              className="form-label form-ele-gap"
                              title={t("reEnterNewPassword")}
                            />
                            <Field
                              className="textFiled form-btn-gap radius-4"
                              name="confirmPassword"
                              placeholder={t("resetPassword.maskedText")}
                              id="change-pass-field"
                              type="password"
                              value={values.confirmPassword}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={
                                errors.confirmPassword &&
                                touched.confirmPassword
                              }
                            />
                            <ActionButton
                              label={t("Save")}
                              loading={actionProgress}
                            />
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
export default ResetPassword;
